import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  highlight(event) {
    const container = this.element.closest('.space-y-3')
    if (!container) return

    container.querySelectorAll('label').forEach(label => {
      label.classList.remove('border-indigo-500', 'bg-indigo-50')
      label.classList.add('border-gray-200')
    })

    const selectedLabel = event.target.closest('label')
    if (selectedLabel) {
      selectedLabel.classList.remove('border-gray-200')
      selectedLabel.classList.add('border-indigo-500', 'bg-indigo-50')
    }
  }
}
